export enum PrescriptionStatusEnum {
  Pending = 1,
  Success,
  Canceled,
};